{{each items}}
    <sk-temp-field class="sk-temp-field" id="sk-field-{{$value.fieldName}}">

    {{if $value.displayType == 1}}
    <% include('./text.art', {field: $value, type: type}) %>
    {{/if}}

    {{if $value.displayType == 2}}
    <% include('./textarea.art', {field: $value, type: type}) %>
    {{/if}}

    {{if $value.displayType == 3}}
    <% include('./radio.art', {field: $value, type: type}) %>
    {{/if}}

    {{if $value.displayType == 4}}
    <% include('./select.art', {field: $value, type: type}) %>
    {{/if}}

    {{if $value.displayType == 5}}
    <% include('./checkbox.art', {field: $value, type: type}) %>
    {{/if}}

    {{if $value.displayType == 6}}
    <% include('./checkbox-select.art', {field: $value, type: type}) %>
    {{/if}}

    {{if $value.displayType == 7}}
    <% include('./img.art', {field: $value, type: type}) %>
    {{/if}}

    {{if $value.displayType == 8}}
    <% include('./file.art', {field: $value, type: type}) %>
    {{/if}}

    {{if $value.displayType == 9}}
    <% include('./time.art', {field: $value, type: type}) %>
    {{/if}}

    {{if $value.displayType == 110}}
    <% include('./line.art', {field: $value, type: type}) %>
    {{/if}}

    {{if $value.displayType == 120}}
    <% include('./desc.art', {field: $value, type: type}) %>
    {{/if}}

    {{if $value.displayType == 119}}
    <% include('./policy.art', {field: $value, type: type}) %>
    {{/if}}

    </sk-temp-field>

{{/each}}